import { isSameDay, parseISO } from "date-fns";
import { useEffect, useState } from 'react';
import { LppItem, StatusFilter } from "../../../../model/Hublang";
import { fetchGetLPPAll, fetchPrintLpp, fetchPetugasAvailable, fetchPatchVerif} from '../../../../controller/dashboard/Loket';
import { fetchLppListBukaDataGet, fetchLppListWPetugas } from "../../../../controller/dashboard/Cekmeter";
import { SquareCheckBig } from "lucide-react";

export default function Lpp(){
    const [petugas, setPetugas] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [loadingPreviewBackend, setLoadingPreviewBackend] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default
    const [petugasList, setPetugasList] = useState<any[] >([]);
    const [selectedIndexPetugas, setSelectedIndexPetugas] = useState<number | null>(null);
    const [statusFilter, setStatusFilter] = useState<StatusFilter>({
        status: 'all',
        petugas: 'all',
        kecamatan: 'all',
        blnbyr: 'all',
        klas: 'all',
        pelanggan: 'all',
        bln: 'all',
        thn: 'all',
        kategori: 'all',
        nama: 'all',
        tanggal: null
    });
    const [statusLength, setStatusLength] = useState('10');
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showPreviewBackendModal, setShowPreviewBackendModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [lppData, setLppData] = useState<LppItem[]>([]);
    const [selectedLpp, setSelectedLpp] = useState<LppItem | null>(null);
    const [selectedLppList, setSelectedLppList] = useState<LppItem[]>([]);

    const uniqueNama = Array.from(new Set(lppData.map(item => item.nama))).filter(Boolean);
    const uniqueKlas = Array.from(new Set(lppData.map(item => item.klas))).filter(Boolean);
    const uniqueStatus = Array.from(new Set(lppData.map(item => item.status))).filter(Boolean);
    const uniquePetugas = Array.from(new Set(lppData.map(item => item.petugas))).filter(Boolean);
    const uniqueKategori = Array.from(new Set(lppData.map(item => item.kategori))).filter(Boolean);
    const uniqueKecamatan = Array.from(new Set(lppData.map(item => item.kecamatan))).filter(Boolean);
    const uniquePelanggan = Array.from(new Set(lppData.map(item => item.pelanggan))).filter(Boolean);
    const uniqueBln = Array.from(new Set(lppData.map(item => item.bln))).filter(Boolean).sort((a, b) => Number(a) - Number(b));
    const uniqueThn = Array.from(new Set(lppData.map(item => item.thn))).filter(Boolean).sort((a, b) => Number(a) - Number(b));
    const uniqueBlnByr = Array.from(new Set(lppData.map(item => item.blnbyr))).filter(Boolean).sort((a, b) => Number(a) - Number(b)); 


    const filteredLpps = lppData.filter(lpp => {
        const matchesSearch =lpp.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
                lpp.nsb.includes(searchTerm) ||
                lpp.nama.includes(searchTerm) ||
                lpp.petugas.includes(searchTerm) ||
                lpp.kecamatan.includes(searchTerm) ||
                lpp.periode.includes(searchTerm) ||
                lpp.klas.includes(searchTerm) ||
                lpp.pelanggan.includes(searchTerm) ||
                lpp.status.includes(searchTerm) ||
                lpp.kategori.includes(searchTerm) ||
                lpp.blnbyr.includes(searchTerm) ||
                lpp.bln.includes(searchTerm) ||
                lpp.thn.includes(searchTerm);

            const matchesTanggal = !statusFilter.tanggal || isSameDay(new Date(lpp.tglbyr), statusFilter.tanggal);

            const matchesStatus = 
                (statusFilter.status === 'all' || lpp.status === statusFilter.status) &&
                (statusFilter.nama === 'all' || lpp.nama === statusFilter.nama) &&
                (statusFilter.petugas === 'all' || lpp.petugas === statusFilter.petugas) &&
                (statusFilter.kecamatan === 'all' || lpp.kecamatan === statusFilter.kecamatan) &&
                (statusFilter.blnbyr === 'all' || lpp.blnbyr === statusFilter.blnbyr) &&
                (statusFilter.klas === 'all' || lpp.klas === statusFilter.klas) &&
                (statusFilter.pelanggan === 'all' || lpp.pelanggan === statusFilter.pelanggan) &&
                (statusFilter.bln === 'all' || lpp.bln === statusFilter.bln) &&
                (statusFilter.thn === 'all' || lpp.thn === statusFilter.thn) &&
                (statusFilter.kategori === 'all' || lpp.kategori === statusFilter.kategori);

            return matchesSearch && matchesStatus && matchesTanggal;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentLpps = filteredLpps.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredLpps.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataLpp = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetLPPAll(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {

            const today = new Date();
            today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any) => ({
                    no: item[0],
                    petugas: item[1]?.trim() || "Unknown",
                    kecamatan: item[2] || "Unknown",
                    periode: item[3] || "Unknown",
                    nsb: item[4] || "Unknown",
                    nama: item[5]?.trim() || "Unknown",
                    klas: item[6] || "Unknown",
                    pelanggan: item[7] || "Unknown",
                    status: item[8] || "Unknown",
                    kategori: item[9] || "Unknown",
                    hair: parseFloat(item[10]) || 0,
                    adm: parseFloat(item[11]) || 0,
                    denda: parseFloat(item[12]) || 0,
                    total: parseFloat(item[13]) || 0,
                    tglbyr: item[14] || "Unknown",
                    blnbyr: item[15] || "Unknown",
                    bln: item[16] || "Unknown",
                    thn: item[17] || "Unknown"
                }));

                // Sorting berdasarkan tanggal bayar (tglbyr) dari yang terbaru ke yang terlama
                const sortedData = processedData.sort((a, b) => {
                    const dateA = new Date(a.tglbyr);
                    const dateB = new Date(b.tglbyr);

                    // Prioritaskan data dengan tanggal >= hari ini
                    if (dateA >= today && dateB < today) return -1;
                    if (dateA < today && dateB >= today) return 1;

                    // Jika kedua tanggal >= hari ini atau < hari ini, urutkan berdasarkan tanggal terbaru
                    return dateB.getTime() - dateA.getTime();
                });
                setLppData(sortedData); // Simpan data yang sudah diproses ke state
            } else {
                setLppData([]); // Jika respons tidak valid, set data ke array kosong
            }
        } catch (error) {
            setLppData([]); // Set data ke array kosong jika terjadi error
        } finally {
            // const petugas_cache = await getCache("current_user");
            // setPetugas(petugas_cache.username);
            setLoading(false); // Set loading state ke false setelah selesai
        }
    };

    const handlePreviewDetail = (lpp: LppItem) => {
        setSelectedLpp(lpp);
        setShowPreviewModal(true);
    };

    // const handlePreviewBackend =  async () => {
    //     setShowPreviewBackendModal(true);
    //     setLoadingPreviewBackend(true);
    //     setPdfUrl(null);
    //     try {
    //         const printResult = await fetchPrintLpp(filteredLpps);
    //         if (printResult.preview_data) {
    //             const url = process.env.REACT_APP_API_URL + "/hublang/lpp/download/" + printResult.preview_data;
    //             setPdfUrl(url);
    //         }
    //     } finally {
    //         setLoadingPreviewBackend(false);
    //     }
    // };

    const handleListLPPMake = async (lpp : LppItem[]) => {
        setShowPreviewModal(true);
        setSelectedLppList(lpp);
    }

    const handlVerifAsAsmenLoan = () => {
        
    }

    const initDataPetugasAvailable = async () => {
        let mounted2 = true;

        setLoading(true);
        try {
            const resp = await fetchPetugasAvailable();
            if(!mounted2) return;
            
            const arr = Array.isArray(resp) ? resp : (resp?.data && Array.isArray(resp.data) ? resp.data : []);
            setPetugasList(arr);
        } catch (err: any) {
            if(!mounted2) return;
        } finally {
            if (!mounted2) return;
        }
        return () => { mounted2 = false; };
    }

    const handlePickPetugasFromList = (petugas : string ) => {
        setPetugas(petugas);
    }
    

    useEffect(() => {
        initDataLpp();
        initDataPetugasAvailable();
        setItemsPerPage(Number(statusLength === 'all' ? lppData.length : statusLength))
    }, []);

    return(
        <>
            <div>
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                {/* <div className="text-sm text-gray-500 mb-2"> Buka data { petugas ? <>( {petugas} )</> : '' } : </div> */}
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                        <div className="w-full md:w-72 flex flex-col space-y-4" style={{ width: '10rem' }}>
                            <div>
                                <div className="flex flex-col space-y-2 max-h-64 overflow-y-auto pr-2">
                                    {loading ? (
                                    <div className="text-sm text-gray-500">Loading...</div>
                                    ) : true ? (
                                    petugasList.map((item, idx) => {
                                        // const dateStr = item.TANGGAL ?? item.tanggal ?? item.date ?? "";
                                        return (
                                            <>
                                            <button
                                                key={String(idx)}
                                                onClick={() => handlePickPetugasFromList(item.PETUGAS)}
                                                className={`text-left w-full rounded-md px-3 py-2 border transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 ${
                                                    selectedIndexPetugas === idx ? "bg-sky-50 border-sky-300" : "bg-white border-gray-200"
                                                }`}
                                                aria-pressed={selectedIndexPetugas === idx}
                                            >
                                                <div className="text-sm font-medium">{item.PETUGAS}</div>
                                            </button>
                                            </>
                                        );
                                    })
                                    
                                    ) : (
                                        <div className="text-sm text-gray-500">Tidak ada data</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="flex-1 min-w-0 overflow-auto">
                            {
                                !loading && petugas != "" ? (<DetailPreviemLppListModal Petugas={petugas}/>)
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div> 

            {/* Print LPP Modal */}
            {/* {showPreviewModal && <DetailPreviewModal lppDetail={selectedLppList} stateShowModal={setShowPreviewModal} petugas={petugas}/>}
            
            {showPreviewBackendModal && ( <DetailPreviewBackendModal lppDetail={selectedLpp} stateShowModal={setShowPreviewBackendModal} pdfUrl={pdfUrl} loading={loadingPreviewBackend} /> )} */}
        </>
    )
}

// export const DetailPreviewModal = ({ lppDetail, stateShowModal, petugas } : { 
//   lppDetail : LppItem[] | null,
//   petugas : string;
//   stateShowModal : (show: boolean) => void | false
// }) =>{
//     const [controlLppStatus, setControlLppStatus] = useState<"tabletoday" | "listed" | "tabletodaymake">("tabletoday");

//     const [tanggalBuat, setTanggalBuat] = useState<Date | null>(null);

//     useEffect(() => {
//         console.log(tanggalBuat);
//     },[tanggalBuat])

//     const handleTanggalBuat = (tanggal : Date | null) => {
//         setTanggalBuat(tanggal);
//     }

//     let filteredLppDetail = lppDetail?.filter(lpp => {
//         const matchesTanggal = isSameDay(new Date(lpp.tglbyr), new Date());
//         const matchesStatus = (lpp.petugas === petugas);

//         return matchesTanggal && matchesStatus;
//     });

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-8xl mx-4 p-8">

//                 <div className="flex items-center justify-between mb-6 print:hidden">
//                 <h3 className="text-xl font-semibold text-gray-800">
//                     Preview Laporan Pembayaran
//                 </h3>
//                     <div className="flex gap-2">            
//                         <button
//                         onClick={() => stateShowModal(false)}
//                         className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                         >
//                         ✕
//                         </button>
//                     </div>
//                 </div>

//                 {/* Controls 1*/}
//                 <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//                     <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
//                         <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-3">
//                             <button 
//                                 onClick={() => { setControlLppStatus("tabletoday"); }}
//                                 className={`flex items-center px-4 py-2 text-white bg-${controlLppStatus === 'tabletoday' ? 'blue' : 'gray'}-600 rounded-lg hover:bg-${controlLppStatus === 'tabletoday' ? 'blue' : 'gray'}-700 transition-colors`}>
//                                 Data Hari ini
//                             </button>
                            
//                             <button
//                                 onClick={() => { setControlLppStatus("listed"); }}
//                                 className={`flex items-center px-4 py-2 text-white bg-${controlLppStatus === 'listed' ? 'blue' : 'gray'}-600 rounded-lg hover:bg-${controlLppStatus === 'tabletoday' ? 'blue' : 'gray'}-700 transition-colors`}>
//                                 List LPP
//                             </button>                    
//                         </div>

//                         <div className="flex space-x-3">
//                             {
//                                 controlLppStatus === 'tabletoday' ?
//                                 <>
//                                     <button 
//                                         // onClick={ async () => await fetchLppToday(petugas, filteredLppDetail) }
//                                         onClick={ async () => setControlLppStatus('tabletodaymake') }
//                                         className={`flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors`}>
//                                         Buat LPP
//                                     </button>
//                                 </>
//                                 :
//                                 ""
//                             }
//                         </div>
//                     </div>
//                 </div>

//                 {/* { controlLppStatus === "tabletoday" && <DetailPreviewLppTableModal filteredLppDetail={filteredLppDetail} /> } */}
//                 { controlLppStatus === "tabletoday" && <DetailPreviewBeforeLppListModal dataPreview={lppDetail} petugas={petugas} getTanggal={handleTanggalBuat} /> }
//                 { controlLppStatus === "listed" && <DetailPreviemLppListModal Petugas={petugas}/> }
//                 { controlLppStatus === "tabletodaymake" && <TanyaMakeLpp filteredData={lppDetail ?? []} petugas={petugas} controlStatus={setControlLppStatus} tanggal={tanggalBuat ?? null }/>}  
//             </div>
//         </div>
//     )
// };

// export const TanyaMakeLpp = ({ filteredData, petugas, controlStatus, tanggal } : 
//     { 
//         filteredData : LppItem[]; 
//         petugas : string;
//         tanggal : Date | null;
//         controlStatus :  (s: "tabletoday" | "listed" | "tabletodaymake") => void;
//     }) => {

//     let filteredLppDetail = filteredData?.filter(lpp => {
//         const matchesTanggal = tanggal ? isSameDay(new Date(lpp.tglbyr), tanggal) : false;
//         const matchesStatus = (lpp.petugas === petugas);

//         return matchesTanggal && matchesStatus;
//     });

//     let formatted = '';
//     if (tanggal) {
//         const date = new Date(tanggal);
//         formatted = date
//             .toLocaleDateString('id-ID', {
//                 day: '2-digit',
//                 month: '2-digit',
//                 year: 'numeric'
//             })
//             .replace(/\//g, '-');
//     }

//     return(
//         <div className="bg-white rounded-xl shadow-lg p-8 text-center space-y-6">
//             <div className="flex flex-col items-center space-y-3">
//                 <div className="text-4xl text-blue-500">🧾</div>
//                 <h2 className="text-xl font-semibold text-gray-800">
//                     Buat Laporan Pembayaran (LPP) Tanggal yang dipilih : {tanggal?.toLocaleDateString('id-ID', {day: '2-digit',month: 'long',year: 'numeric'})}
//                 </h2>
//                 <p className="text-gray-600 max-w-md mx-auto">
//                     Apakah kamu yakin ingin membuat LPP untuk data pembayaran pada tanggal yang dipilih?
//                     Pastikan semua data sudah diperiksa dengan benar sebelum melanjutkan.
//                 </p>
//             </div>
    
//             <div className="flex justify-center gap-4 mt-6">
//                 <button
//                     onClick={async () => {
//                         await fetchLppToday(petugas, filteredLppDetail, formatted);
//                         controlStatus("tabletoday"); // kembali ke tampilan utama setelah sukses
//                     }}
//                     className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-lg transition-colors"
//                 >
//                 ✅ Ya, Buat Sekarang
//                 </button>
        
//                 <button
//                     onClick={() => controlStatus("tabletoday")}
//                     className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium px-5 py-2 rounded-lg transition-colors"
//                 >
//                 ❌ Batal
//                 </button>
//             </div>
//         </div>   
//     );
// }

// export const DetailPreviewBackendModal = ({ lppDetail, stateShowModal, pdfUrl, loading } : Props) => {
//     return(
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-8xl mx-4 p-8">

//             <div className="flex justify-between items-center mb-2">
//                 <h3 className="text-xl font-semibold">Preview PDF</h3>
//                 <button onClick={() => stateShowModal(false)} className="p-2 hover:bg-gray-100 rounded-lg">✕</button>
//             </div>

//             <div className="flex-1 border rounded overflow-hidden h-[80vh]">
//                 {pdfUrl ? (
//                     <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
//                     <Viewer fileUrl={pdfUrl} />
//                     </Worker>
//                 ) : (
//                     <div className="flex items-center justify-center h-full">Loading PDF...</div>
//                 )}
//                 </div>

//             <button 
//                 disabled={!pdfUrl}
//                 onClick={() => pdfUrl && window.open(pdfUrl, "_blank")}
//                 className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
//             >
//                 Print
//             </button>

//             </div>
//         </div>
//     )
// };

export const DetailPreviewLppTableModal = ({ filteredLppDetail } : { filteredLppDetail : LppItem[] | any }) => (
    <div className="max-h-96 overflow-visible">
        {/* <div className="min-w-full"> */}
        <div className="overflow-x-auto max-w-full">
            <table className="min-w-full table-auto whitespace-nowrap border border-gray-400 text-sm">
            <thead className="bg-gray-100">
                <tr>
                <th className="border px-3 py-2">NO</th>
                <th className="border px-3 py-2">PETUGAS</th>
                <th className="border px-3 py-2">PERIODE</th>
                <th className="border px-3 py-2">NSB</th>
                <th className="border px-3 py-2">NAMA</th>
                <th className="border px-3 py-2">KLS</th>
                <th className="border px-3 py-2">PLGGN</th>
                <th className="border px-3 py-2">KATEGORI</th>
                <th className="border px-3 py-2">HAIR</th>
                <th className="border px-3 py-2">ADM</th>
                <th className="border px-3 py-2">JML</th>
                <th className="border px-3 py-2">DENDA</th>
                <th className="border px-3 py-2">TOTAL</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
            { filteredLppDetail && filteredLppDetail.length > 0 ? (
                <>
                    { filteredLppDetail && filteredLppDetail.length > 0 ? (
                        <tr className="font-bold bg-yellow-100">
                            <th colSpan={13} className="border px-3 py-2 text-center">
                                LLP-A
                            </th>
                        </tr>
                    ) : ''}

                    {filteredLppDetail.map((lpp: any, idx: number) => (
                        <tr key={lpp.no} className="hover:bg-gray-50 transition-colors">
                            <td className="border px-3 py-2 text-center">{idx + 1}</td>
                            <td className="border">{lpp.petugas}</td>
                            <td className="border px-3 py-2 text-center">{lpp.periode}</td>
                            <td className="border px-3 py-2 text-center">{lpp.nsb}</td>
                            <td className="border px-3 py-2">{lpp.nama}</td>
                            <td className="border px-3 py-2 text-center">{lpp.klas}</td>
                            <td className="border px-3 py-2 text-center">{lpp.pelanggan}</td>
                            <td className="border px-3 py-2 text-center">{lpp.kategori}</td>
                            <td className="border px-3 py-2 text-right">{lpp.hair.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                            <td className="border px-3 py-2 text-right">{lpp.adm.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                            <td className="border px-3 py-2 text-right">{(lpp.hair + lpp.adm).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                            <td className="border px-3 py-2 text-right">{lpp.denda.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                            <td className="border px-3 py-2 text-right font-semibold">{lpp.total.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        </tr>
                    ))}

                    <tr className="font-bold bg-blue-100">
                        <td colSpan={8} className="border px-3 py-2 text-center">
                        TOTAL
                        </td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.hair) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.adm) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.hair) + (Number(t.adm)) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.denda) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.total) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                    </tr>

                    <tr className="font-bold bg-yellow-100">
                        <th colSpan={13} className="border px-3 py-2 text-center">
                            LPP-A TRANSFER
                        </th>
                    </tr>

                    <tr className="font-bold bg-blue-100">
                        <td colSpan={8} className="border px-3 py-2 text-center">
                        TOTAL
                        </td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.hair) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.adm) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.hair) + (Number(t.adm)) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.denda) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.total) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                    </tr>
                </>
                    ) : (
                    <tr>
                        <td colSpan={13} className="text-center py-4 text-gray-500">
                        Tidak ada data
                        </td>
                    </tr>
                    )
                }
                
            </tbody>
            </table>
        </div>
    </div>
)

export const DetailPreviemLppListModal = ({ Petugas } : { Petugas : string } ) => {
    const [tanggalFilter, setTanggalFilter] = useState<Date | null>(null);
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [filteredLppDetail, setFilteredLppDetail] = useState<any[]>([]);
    const [tanggalList, setTanggalList] = useState<any[] >([]);
    const [loading, setLoading] = useState(false);
    const [tableState, setTableState] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [tableLppId, setTableLppId] = useState<any>({});
    const [manajerHublang, setManajerHublang] = useState<string>('');
    const [asmenPenagihan, setAsmenPenagihan] = useState<string>('');
    const [asmenKas, setAsmenKas] = useState<string>('');
    const [petugasLoket, setPetugasLoket] = useState<string>('');

    const load = async (mounted : boolean) => {
        setLoading(true);
        try {
          const resp = await fetchLppListWPetugas(Petugas);
          if (!mounted) return;
          // contoh: resp bisa berupa array atau { data: [...] }
          const arr = Array.isArray(resp) ? resp : (resp?.data && Array.isArray(resp.data) ? resp.data : []);
          setTanggalList(arr);
        } catch (err: any) {
          if (!mounted) return;
          setError(String(err?.message ?? err));
        } finally {
          if (!mounted) return;
          setPetugasLoket(Petugas);
          setLoading(false);
        }
    };    

    const handlePatch = async (id : any, verif : string) => {
        const response = await fetchPatchVerif(id.id_data, verif);
        if(response.status == 204 || response.status == 200) {
            handlePickTanggalFromList(id.id_idx, Petugas)
        }
    }

    useEffect(() => {
        let mounted = true;
        load(mounted);
        return () => { mounted = false; };
    }, [Petugas]);

    const handlePickTanggalFromList = async (idx: number, petugas: string) => {
        const item = await tanggalList[idx];

        if (!item) return;

        const dateStr: string = item.TANGGAL ?? item.tanggal ?? item.date ?? "";
        if (!dateStr) {
          setSelectedIndex(idx);
          setSelectedDate(null);
          return;
        }

        const data = await fetchLppListBukaDataGet(dateStr, petugas);
        setTableState(false);

        try {
            setTableLppId({ id_data : data.data[0].id, id_idx : idx });
            setFilteredLppDetail(data.data[0].DATA_LPP);
            setManajerHublang(data.data[0].MANAJER_HUBLANG);
            setAsmenPenagihan(data.data[0].ASMEN_PENAGIHAN);
            setAsmenKas(data.data[0].ASMEN_KAS);
            setTableState(true);
        } catch (e){
            setTableState(false);
        }

        let parsed: Date;
        try {
          parsed = parseISO(dateStr);
          if (isNaN(parsed.getTime())) {
            parsed = new Date(dateStr.replace(/-/g, "/"));
          }
        } catch {
          parsed = new Date(dateStr.replace(/-/g, "/"));
        }
    
        setSelectedIndex(idx);
        setSelectedDate(parsed);
        setTanggalFilter(parsed);
    };

    // debug
    //   useEffect(() => {
    //     console.log("selectedIndex:", selectedIndex);
    //     console.log("selectedDate:", selectedDate ? format(selectedDate, "yyyy-MM-dd") : null);
    //     console.log("filteredLppDetail:", filteredLppDetail);
    // }, [selectedIndex, selectedDate, filteredLppDetail]);

    return (
        
        <div>
            <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                    <div className="w-full md:w-72 flex flex-col space-y-4" style={{ width : '8rem' }}>
                        <div>
                            <div className="text-sm text-gray-500 mb-2"> Buka data <br />{ petugasLoket ? <>( {petugasLoket} )</> : '' } : </div>
                            <div className="flex flex-col space-y-2 max-h-64 overflow-y-auto pr-2">
                                {loading ? (
                                <div className="text-sm text-gray-500">Loading...</div>
                                ) : tanggalList && tanggalList.length ? (
                                    tanggalList.map((item, idx) => {
                                        const dateStr = item.TANGGAL ?? item.tanggal ?? item.date ?? "";
                                        return (
                                            <button
                                                key={String(idx)}
                                                onClick={() => handlePickTanggalFromList(idx, Petugas)}
                                                className={`text-left w-full rounded-md px-3 py-2 border transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 ${
                                                    selectedIndex === idx ? "bg-sky-50 border-sky-300" : "bg-white border-gray-200"
                                                }`}
                                                aria-pressed={selectedIndex === idx}
                                            >
                                                <div className="text-sm font-medium">{dateStr}</div>
                                            </button>
                                        );
                                    })
                                ) : (
                                <div className="text-sm text-gray-500">Tidak ada data</div>
                                )}
                            </div>
                        </div>
                    </div>
        
                    <div className="flex-1 min-w-0 overflow-auto">
                        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                            {
                                filteredLppDetail && filteredLppDetail.length >= 1 ? 
                                (
                                    <>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
                                            <div className="flex flex-col border rounded-lg p-3 bg-gray-50">
                                                <span className="font-semibold text-gray-700">Diketahui Oleh Manajer Hublang</span>
                                                <span className="text-gray-800">Sri Rahayu Mbuinga, SE: <br />{ manajerHublang == 'belum' ? 'Belum di verifikasi ❌' : 'Sudah di verifikasi ✅' }</span>
                                            </div>

                                            <div className="flex flex-col border rounded-lg p-3 bg-gray-50">
                                                <span className="font-semibold text-gray-700">Verifikasi Asmen Penagihan</span>
                                                <span className="text-gray-800">{asmenPenagihan == 'belum' ? 'Belum di verifikasi ❌' : 'Sudah di verifikasi ✅'}</span>
                                            </div>

                                            <div className="flex flex-col border rounded-lg p-3 bg-gray-50">
                                                <span className="font-semibold text-gray-700">Verifikasi Asmen Kas</span>
                                                <span className="text-gray-800">{asmenKas == 'belum' ? 'Belum di verifikasi ❌' : 'Sudah di verifikasi ✅'}</span>
                                            </div>

                                            <div className="flex flex-col border rounded-lg p-3 bg-gray-50">
                                                <span className="font-semibold text-gray-700">Petugas Loket</span>
                                                <span className="text-gray-800">Dibuat oleh {petugasLoket}</span>
                                            </div>
                                        </div>

                                        <div style={{ marginTop : 10 }}>
                                            <button
                                            onClick={() => { handlePatch(tableLppId, "penagihan") }}
                                            // className={`flex items-center px-4 py-2 text-white bg-${filteredLpps.length != 0 ? 'blue' : 'gray' }-600 rounded-lg hover:bg-${filteredLpps.length != 0 ? 'blue' : 'gray' }-700 transition-colors`}
                                            className={`flex items-center px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors`}
                                            >
                                                <SquareCheckBig className="w-4 h-4 mr-2" />
                                                Verifikasi Sebagai Asmen Penagihan
                                            </button>
                                        </div>
                                    </>
                                ) :
                                ''
                            }
                            
                        </div>
                        { tableState ? 
                            <DetailPreviewLppTableModal filteredLppDetail={filteredLppDetail} />
                            :
                            <div>
                                Tekan Lagi !
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

// export const DetailPreviewBeforeLppListModal = ({ dataPreview, petugas, getTanggal } : { dataPreview : LppItem[] | any; petugas : string; getTanggal : (tanggal : Date | null) => void } ) => {
//     const [tanggalFilter, setTanggalFilter] = useState<Date | null>(null);

//     const handleChangeTanggal = (date : Date | null) => {
//         setTanggalFilter(date);
//         getTanggal(date);
//     }

//     const filteredLppDetail = dataPreview?.filter((lpp : any) => {
//         const matchesTanggal = !tanggalFilter || isSameDay(new Date(lpp.tglbyr), tanggalFilter);
//         const matchesStatus = (lpp.petugas === petugas)
//         return matchesTanggal && matchesStatus;
//     })

//     return (
//         <div>
//             <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//                 <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
//                     <div className="w-full md:w-72 flex flex-col space-y-4">
//                         <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal bayar (sort)</label>
//                         <DatePicker
//                             selected={tanggalFilter}
//                             onChange={(date: Date | null) => {handleChangeTanggal(date)}}
//                             placeholderText="Pilih tanggal bayar"
//                             dateFormat="dd-MM-yyyy"
//                             className="w-full border border-gray-300 rounded-lg px-3 py-2"
//                             isClearable
//                         />
//                         </div>
//                     </div>
        
//                     <div className="flex-1 min-w-0 overflow-auto">
//                         <DetailPreviewLppTableModal filteredLppDetail={tanggalFilter?filteredLppDetail:{}} />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };